import { render, staticRenderFns } from "./TixMessage.vue?vue&type=template&id=9b64d6ee&"
import script from "./TixMessage.vue?vue&type=script&lang=ts&"
export * from "./TixMessage.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports